<div class="reconciliation-wrapper">
  <div class="detail-header">
    <h3>Outbound Reconciliation</h3>
    <button class="btn-bg-red" (click)="returnToList()">← Return</button>
  </div>

  <div class="reconciliation-toolbar">
    <label>Pickup Date:</label>
    <rms-date [ngModel]="FilterDate" (ngModelChange)="onFilterDateChange($event)"></rms-date>
    <input aria-label="Search reconciliation" placeholder="Order, customer or warehouse" [(ngModel)]="Search" (ngModelChange)="Page = 0">
    <label><input type="checkbox" [(ngModel)]="MissingOnly" (ngModelChange)="Page = 0"> Missing transmissions only</label>
    @if (missingCount > 0) {
    <span class="missing-badge">{{ missingCount }} order(s) not fully transmitted</span>
    }
  </div>
  <p class="reconciliation-help">Checks recorded successful delivery of the latest delivery order and bill of lading. Preparing a document does not mark it sent. {{ FilterDate ? '' : 'Showing the last 90 days and future pickups.' }}</p>
  <p class="email-unavailable" id="reconciliation-email-unavailable"><mat-icon aria-hidden="true">info_outline</mat-icon><span>Email test mode: all documents go only to <strong>m.bray&#64;royalny.com</strong>. No warehouse or customer receives them. Test sends do not clear missing transmissions.</span></p>
  @if (SendingOrderID !== null) { <p role="status">Preparing and sending test documents for order #{{ SendingOrderID }}…</p> }
  @if (SendResult) { <p class="email-unavailable" role="status">{{ SendResult }}</p> }
  @if (SendError) { <p class="status-missing" role="alert">{{ SendError }}</p> }

  @if (Loading) {
  <div class="loading">Loading...</div>
  } @else if (LoadError) {
  <div role="alert">{{ LoadError }} <button (click)="load()">Retry</button></div>
  } @else {
  <div class="reconciliation-table-scroll"><table class="doc-table">
    <thead>
      <tr>
        <th>Order #</th>
        <th>Customer</th>
        <th>Pickup Date</th>
        <th>Warehouse</th>
        <th>DO Sent</th>
        <th>BOL Sent</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (row of pageRows; track row.OrderID) {
      <!-- 5.2.22: rows missing a full transmission get a visible highlight,
           not just a text label, so they're impossible to miss scanning down the list -->
      <tr [class.reconciliation-missing]="!row.FullyTransmitted">
        <td>{{ row.OrderID }}</td>
        <td>{{ row.Customer }}</td>
        <td>{{ row.PickupDate | date:'MM-dd-yyyy':'UTC' }}</td>
        <td>{{ row.Warehouse }}</td>
        <td>{{ row.DOSentDate ? (row.DOSentDate | date:'MM-dd-yyyy h:mm a') : 'No recorded delivery' }}</td>
        <td>{{ row.BOLSentDate ? (row.BOLSentDate | date:'MM-dd-yyyy h:mm a') : 'No recorded delivery' }}</td>
        <td>
          @if (row.FullyTransmitted) {
          <span class="status-ok">Complete</span>
          } @else {
          <span class="status-missing">Incomplete</span>
          }
        </td>
        <td>
          <div class="document-actions" aria-describedby="reconciliation-email-unavailable">
            @if (!row.FullyTransmitted) {
              <span title="Send test copies of missing documents only to m.bray&#64;royalny.com.">
                <button class="document-action" type="button" [disabled]="SendingOrderID !== null" (click)="sendDocuments(row)" aria-describedby="reconciliation-email-unavailable"><mat-icon aria-hidden="true">send</mat-icon>Send missing documents</button>
              </span>
            }
            @if (row.DOFlag || row.BOLFlag) {
              <span title="Resend test copies only to m.bray&#64;royalny.com.">
                <button class="document-action" type="button" [disabled]="SendingOrderID !== null" (click)="sendDocuments(row, true)" aria-describedby="reconciliation-email-unavailable"><mat-icon aria-hidden="true">refresh</mat-icon>Resend</button>
              </span>
            }
          </div>
        </td>
      </tr>
      }
      @if (visibleRows.length === 0) {
      <tr><td colspan="8">No orders to reconcile for this selection.</td></tr>
      }
    </tbody>
  </table></div>
  <div class="reconciliation-toolbar">
    <span>{{ pageStart }}–{{ pageEnd }} of {{ visibleRows.length }} orders</span>
    <button mat-button [disabled]="Page === 0" (click)="Page = Page - 1">Previous</button>
    <button mat-button [disabled]="pageEnd >= visibleRows.length" (click)="Page = Page + 1">Next</button>
  </div>
  }
</div>
